import { memo } from 'react'
import styles from './Icon.module.scss'

// Pre-import all SVGs from assets folder as raw strings
const svgModules = import.meta.glob('/src/assets/*.svg', {
  eager: true,
  query: '?raw',
  import: 'default',
}) as Record<string, string>

interface IconProps {
  name: string // Icon name without extension (e.g., "arrow", "user")
  color?: string
  size?: number | string
  className?: string
  alt?: string
}

export const Icon = memo(function Icon({
  name,
  color = 'currentColor',
  size = 24,
  className = '',
  alt = '',
}: IconProps) {
  const sizeValue = typeof size === 'number' ? `${size}px` : size
  const svgPath = `/src/assets/${name}.svg`
  const svg = svgModules[svgPath]

  if (!svg) {
    console.warn(`Icon not found: ${name}`)
    return null
  }

  const coloredSvg = svg
    .replace(/stroke="[^"]*"/g, `stroke="${color}"`)
    .replace(/fill="(?!none)[^"]*"/g, `fill="${color}"`)

  return (
    <span
      className={`${styles.icon} ${className}`}
      role="img"
      aria-label={alt || name}
      style={{
        width: sizeValue,
        height: sizeValue,
      }}
      dangerouslySetInnerHTML={{ __html: coloredSvg }}
    />
  )
})
